import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// ── Employee navigation ──────────────────────────────────────
const EmployeeNav = () => (
  <>
    <div className="nav-section">Main</div>
    <NavLink to="/" end className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-speedometer2" /><span>Dashboard</span>
    </NavLink>
    <NavLink to="/courses" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-book" /><span>My Courses</span>
    </NavLink>

    <div className="nav-section">My Records</div>
    <NavLink to="/psr-report" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-file-earmark-text" /><span>Monthly Report</span>
    </NavLink>
    <NavLink to="/attendance" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-calendar-check" /><span>Attendance</span>
    </NavLink>

    <div className="nav-section">Account</div>
    <NavLink to="/profile" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-person-circle" /><span>Profile</span>
    </NavLink>
  </>
);

// ── Admin navigation ─────────────────────────────────────────
const AdminNav = () => (
  <>
    <div className="nav-section">Overview</div>
    <NavLink to="/" end className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-speedometer2" /><span>Dashboard</span>
    </NavLink>

    <div className="nav-section">Manage</div>
    <NavLink to="/users" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-people" /><span>Employees</span>
    </NavLink>
    <NavLink to="/courses" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-book" /><span>Courses</span>
    </NavLink>
    <NavLink to="/course-builder" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-tools" /><span>Course Builder</span>
    </NavLink>

    <div className="nav-section">Review</div>
    <NavLink to="/psr-review" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-clipboard-check" /><span>Monthly Reports</span>
    </NavLink>
    <NavLink to="/attendance-mgr" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-calendar-check" /><span>Attendance</span>
    </NavLink>
    <NavLink to="/reports" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-bar-chart" /><span>Reports</span>
    </NavLink>

    <div className="nav-section">Tools</div>
    <NavLink to="/csv-import" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-file-earmark-arrow-up" /><span>CSV Import</span>
    </NavLink>

    <div className="nav-section">Account</div>
    <NavLink to="/profile" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
      <i className="bi bi-person-circle" /><span>Profile</span>
    </NavLink>
  </>
);

// ── Sidebar component ────────────────────────────────────────
export default function Sidebar({ show, onClose, onCollapseChange }) {
  const { user, logout, isSupervisor } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleCollapse = () => {
    const next = !collapsed;
    setCollapsed(next);
    onCollapseChange?.(next);
    if (next) onClose?.();
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className={`sidebar${collapsed ? ' collapsed' : ''}${show ? ' show' : ''}`}>

      {/* Brand */}
      <div className="brand">
        <div className="brand-icon">
          <i className="bi bi-mortarboard-fill" style={{ color: '#1e40af', fontSize: '1rem' }} />
        </div>
        {!collapsed && (
          <div className="brand-text">
            <p>LMS Portal</p>
            <p>{isSupervisor ? 'Admin' : 'Employee'}</p>
          </div>
        )}
        <button className="brand-collapse" onClick={handleCollapse}
          title={collapsed ? 'Expand' : 'Collapse'}>
          <i className={`bi bi-chevron-${collapsed ? 'right' : 'left'}`} style={{ fontSize: '.8rem' }} />
        </button>
      </div>

      {/* Navigation */}
      <nav>
        {isSupervisor ? <AdminNav /> : <EmployeeNav />}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <div className="sidebar-avatar">
          {(user?.name?.[0] ?? 'U').toUpperCase()}
        </div>
        {!collapsed && (
          <>
            <div className="sidebar-user">
              <div className="sidebar-user-name">{user?.name}</div>
              <div className="sidebar-user-role">
                {isSupervisor ? 'Admin' : (user?.employee_id ?? 'Employee')}
              </div>
            </div>
            <button className="sidebar-logout" onClick={handleLogout} title="Logout">
              <i className="bi bi-box-arrow-right" style={{ fontSize: '.95rem' }} />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
